/* eslint-disable no-undef */
export default {
  yapps: {
    api: {
      url: 'https://api.yapps.app',
      key: 'lOSk1plngG81nSXYqsZx09cJviRzvMG66rksYiD4',
    },
    qrCodeBaseUrl:
      process.env.REACT_APP_QR_CODE_BASE_URL || 'https://gotoyapps.com',
    siteUrl: process.env.REACT_APP_SITE_URL || 'https://yapps.app',
    paypalPlanId:
      process.env.REACT_APP_PAYPAL_PLAN_ID || 'P-8VE24937K9431242NNIF3WSY',
    paypalClientId:
      process.env.REACT_APP_PAYPAL_CLIENT_ID ||
      'ASabNZKvSe2MPOH6z7HqhsuhxFQP6bSjut4oW37TzKjifN7hO20aus_NtO9-A9OVoi6NrBh695J9Q3ie',
    supportPath: process.env.REACT_APP_SUPPORT_PATH || 'support',
    appPath: process.env.REACT_APP_APP_PATH || 'app',
    messagePath: process.env.REACT_APP_MESSAGE_PATH || 'message',
    paypalPath: process.env.REACT_APP_PAYPAL_PATH || 'paypal',
    stripePath: process.env.REACT_APP_STRIPE_PATH || 'stripe',
  },
};
